import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

import { ref } from 'vue';
import { useDisplay } from 'vuetify';


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: ['itens'],
  setup(__props) {

const props = __props;


const { xs } = useDisplay();
const tab = ref(props.itens[0].key);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn_toggle, {
              modelValue: tab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
              class: "fill-height"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.itens, (item, index) => {
                  return (_openBlock(), _createBlock(_component_v_btn, {
                    key: index,
                    stacked: "",
                    value: item.key,
                    class: _normalizeClass(_unref(xs) ? 'pa-2' : 'pa-5')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.icon), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("p", {
                        class: _normalizeClass(["text-capitalize mt-2", _unref(xs) ? 'text-subtitle-2' : ''])
                      }, _toDisplayString(item.title), 3)
                    ]),
                    _: 2
                  }, 1032, ["value", "class"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.itens, (item) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: item.key,
        class: "mt-10"
      }, [
        _renderSlot(_ctx.$slots, item.key)
      ])), [
        [_vShow, tab.value === item.key]
      ])
    }), 128))
  ], 64))
}
}

})